import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { EditDialogColumn } from 'react-md';

import TooltipFontIcon from '../TooltipFontIcon';
import { invokeBackendApi } from '../../libs/awsLib';
import { nameValueReducer } from '../../utils/reducers';
import UsersTab from './UsersTab';

class Drivers extends React.PureComponent {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      psychologists: [],
      imeis: [],
    };
  }

  componentDidMount() {
    this.loadPsychologists();
    this.loadImeis();
  }

  getPsyDisplayName = (psySub) => {
    const psy = this.state.psychologists.find(p => p.attr.sub === psySub);
    return psy && `${psy.attr.name} ${psy.attr.family_name}`;
  };

  loadPsychologists = () => {
    this.users('psyGroup')
      .then(results => this.setState({
        isLoading: false,
        psychologists: results.map(u => (
          { ...u, attr: u.Attributes.reduce(nameValueReducer, {}) }
        )),
      }))
      .catch(e => alert(e));
  }


  loadImeis = () => {
    this.imeis()
      .then(results =>
        this.setState({ imeis: results }))
      .catch(e => alert(e));
  }

  users = groupName =>
    invokeBackendApi({ path: '/users', queryParams: { groupName } });

  imeis = () =>
    invokeBackendApi({ path: '/availableBlackboxes' });


  render() {
    const { intl, ...childProps } = this.props;
    const { psychologists, imeis, isLoading } = this.state;

    const props = {
      group: 'driverGroup',
      tabTitle: intl.formatMessage({ id: 'adminDashboard.tabs.drivers' }),
      displayedAttributes: [
        {
          tableHeader: intl.formatMessage({ id: 'adminDashboard.users.firstName' }),
          attributeKey: 'name',
          editor: {
            style: { minWidth: '150px' },
            inline: true,
          },
        },
        {
          tableHeader: intl.formatMessage({ id: 'adminDashboard.users.lastName' }),
          attributeKey: 'family_name',
          editor: {
            style: { minWidth: '150px' },
            inline: true,
          },
        },
        {
          tableHeader: intl.formatMessage({ id: 'adminDashboard.users.birthdate' }),
          attributeKey: 'birthdate',
          editor: {
            style: { minWidth: '100px' },
            inline: true,
          },
        },
        {
          tableHeader: intl.formatMessage({ id: 'adminDashboard.users.email' }),
          grow: true,
          attributeKey: 'email',
          editor: {
            inline: true,
            updatable: false,
          },
        },
        {
          tableHeader: intl.formatMessage({ id: 'adminDashboard.drivers.psychologist' }),
          attributeKey: 'custom:assignedPsy',
          editor: {
            style: { minWidth: '180px' },
            menuItems: ['', ...psychologists.map(p => ({ label: `${p.attr.name} ${p.attr.family_name}`, value: p.attr.sub }))],
          },
          display: attributeValue => (attributeValue && this.getPsyDisplayName(attributeValue)),
        },
        {
          tableHeader: intl.formatMessage({ id: 'adminDashboard.drivers.imei' }),
          attributeKey: 'custom:assignedBlackbox',
          editor: {
            id: 'imei_autocomplete',
            block: true,
            style: { minWidth: '150px' },
            data: imeis,
          },
        },
        {
          attributeKey: 'custom:comment',
          editor: {
            id: 'comment_editor',
            large: true,
            maxLength: 200,
            rows: 1,
            maxRows: 6,
            placeholder: intl.formatMessage({ id: 'adminDashboard.users.clickEnterComment' }),
            anchor: {
              x: EditDialogColumn.HorizontalAnchors.INNER_RIGHT,
              y: EditDialogColumn.VerticalAnchors.BOTTOM,
            },
          },
          display: attributeValue => (
            attributeValue &&
            <TooltipFontIcon tooltipLabel={<div className="myTooltip">{attributeValue}</div>}>
              comment
            </TooltipFontIcon>
          ),
        },
      ],
    };
    return !isLoading && <UsersTab {...childProps} {...props} onChange={this.loadImeis} />;
  }
}

export default injectIntl(Drivers);



// WEBPACK FOOTER //
// ./src/components/Users/Drivers.js